import { api } from "@/boot/axios";
import { LocalStorage } from "quasar";


export const login = async ({ commit }, user) => {
  try {
    const resp = await api.post('/auth/request_token/', user)
    if (resp.data.role == 'mentor') {
      api.defaults.headers.common['Authorization'] = `Token ${resp.data.access_token}`
      commit('setLogin', resp.data)
      LocalStorage.set('auth._token', resp.data.access_token)

      return { success: true, message: 'Bienvenido' }
    } else {
      return { success: false, message: 'No tienes acceso' }
    }
  } catch (error) {
    console.log(error)
    return { success: false, message: 'Correo / contraseña incorrecto' }
  }
}

export const setLogin = async ({commit}, user) => {
  try {
    commit('setLogin', user)
  } catch (error) {
    console.log(error)
  }
}

export const logout = async ({commit}) => {
  try {
    await api.post('/auth/revoke_token/')
    delete api.defaults.headers.common["Authorization"]
    commit('setLogout')
    LocalStorage.remove('auth._token')
    return { success: true, message: 'Adios' }
  } catch (error) {
    delete api.defaults.headers.common["Authorization"]
    LocalStorage.remove('auth._token')
    return { success: false, message: 'Sesión cerrada' }
  }
}

export const logoutLocal = ({commit}) => {
  LocalStorage.remove('auth._token')
  commit('setLogout')
  delete api.defaults.headers.common["Authorization"]
  return { success: true, message: 'Sesión cerrada' }
}
